import userService from "../providers/userService";

var timer;
var timerStart;
var timeSpentOnSite = getTimeSpentOnSite();

function getTimeSpentOnSite() {
    timeSpentOnSite = parseInt(sessionStorage.getItem('timeSpentOnSite'));
    timeSpentOnSite = isNaN(timeSpentOnSite) ? 0 : timeSpentOnSite;
    return timeSpentOnSite;
}

function getTimeSpentOnSiteInSeconds() {
    timeSpentOnSite = parseInt(sessionStorage.getItem('timeSpentOnSite'));
    timeSpentOnSite = isNaN(timeSpentOnSite) ? 0 : timeSpentOnSite;
    return parseInt(timeSpentOnSite / 1000);
}

function startCounting() {
    console.log('[startCounting]')
    timerStart = Date.now();
    timer = setInterval(function () {
        timeSpentOnSite = getTimeSpentOnSite() + (Date.now() - timerStart);
        sessionStorage.setItem('timeSpentOnSite', timeSpentOnSite);
        timerStart = parseInt(Date.now());
        // Convert to seconds
        // console.log('[timeSpentOnSite]', parseInt(timeSpentOnSite / 1000));
    }, 1000);
}

function clearCounting() {
    console.log('[clearCounting]');
    sessionStorage.removeItem('timeSpentOnSite');
    clearInterval(timer);
}

var stopCountingWhenWindowIsInactive = true;

if (stopCountingWhenWindowIsInactive) {

    if (typeof document.hidden !== "undefined") {
        var hidden = "hidden",
            visibilityChange = "visibilitychange",
            visibilityState = "visibilityState";
    } else if (typeof document.msHidden !== "undefined") {
        var hidden = "msHidden",
            visibilityChange = "msvisibilitychange",
            visibilityState = "msVisibilityState";
    }
    var documentIsHidden = document[hidden];

    document.addEventListener(visibilityChange, function () {
        if (documentIsHidden != document[hidden]) {
            if (document[hidden]) {
                // Window is inactive
                clearInterval(timer);
                console.log('window inactive');
            } else {
                // Window is active
                startCounting();
                console.log('window active');
            }
            documentIsHidden = document[hidden];
        }
    });
}

async function stopCountAndSendSpentTime(checkTime = true) {
    // send to api spend time on platform
    console.log('[stopCountSpentTime]');
    const time = getTimeSpentOnSiteInSeconds();
    if (checkTime) {
        if (time > 30) {
            await sendSpentTime(time);
        }
    } else {
        await sendSpentTime(time);
    }
    clearCounting();
}
async function sendSpentTime(time) {
    console.log('[sendSpentTime] sending spent time to server: ', time);
    await userService.updateTimeSpent({ time }, new URLSearchParams());
}

export { getTimeSpentOnSite, getTimeSpentOnSiteInSeconds, startCounting, clearCounting, stopCountAndSendSpentTime };